/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseGetSettingResponse
 */
export interface ResponseGetSettingResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetSettingResponse
     */
    isSeinoCorrection?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetSettingResponse
     */
    seinoCorrectionValue?: number;
}

/**
 * Check if a given object implements the ResponseGetSettingResponse interface.
 */
export function instanceOfResponseGetSettingResponse(value: object): value is ResponseGetSettingResponse {
    return true;
}

export function ResponseGetSettingResponseFromJSON(json: any): ResponseGetSettingResponse {
    return ResponseGetSettingResponseFromJSONTyped(json, false);
}

export function ResponseGetSettingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetSettingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSeinoCorrection': json['is_seino_correction'] == null ? undefined : json['is_seino_correction'],
        'seinoCorrectionValue': json['seino_correction_value'] == null ? undefined : json['seino_correction_value'],
    };
}

export function ResponseGetSettingResponseToJSON(json: any): ResponseGetSettingResponse {
    return ResponseGetSettingResponseToJSONTyped(json, false);
}

export function ResponseGetSettingResponseToJSONTyped(value?: ResponseGetSettingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_seino_correction': value['isSeinoCorrection'],
        'seino_correction_value': value['seinoCorrectionValue'],
    };
}

